import React from "react";
import ReactDOM from "react-dom/client"; // Note the change here
import App from "./App";
import "./style.css";

// Create a root and render the application
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
